import { ClockIcon } from '@rsos/assets/icons';
import LocationTime from '@rsos/components/capstone/DataCards/DataCardLocation/LocationTime';
import { Box } from '@rsos/components/capstone/base';

interface Props {
  timestamp: number;
}

export const DateInformation = ({ timestamp }: Props) => {
  // Mirror the expanded pane: LocationTime guards falsy timestamps (e.g. the
  // `0` fallback) and parses natively, instead of forcing a UTC reinterpret
  // the way the old formatter did.
  if (!timestamp) {
    return null;
  }

  return (
    <Box horizontal align="center" marginTop={2}>
      <ClockIcon color="primaryText" width={12} height={12} />
      <Box marginLeft={2}>
        <LocationTime
          size="xsmall"
          timeAgoTextSize="small"
          timeBoxTextSize="xsmall"
          timeStamp={timestamp}
          noPadding
        />
      </Box>
    </Box>
  );
};
